import React, { useEffect, useState } from 'react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-white border-t border-gray-200 px-4 py-3" data-id="element-87">
      <div className="flex items-center justify-between gap-3" data-id="element-88">
        <div className="flex flex-col leading-tight" data-id="element-89">
          <span className="text-[11px] text-gray-400 line-through" data-id="element-90">
            $50.000
          </span>
          <span className="text-base font-semibold text-forest" data-id="element-91">$19.990</span>
        </div>
        <a href="https://impulsodigital.vip/cart/44794622902358:1" className="flex-1 bg-forest text-white text-center py-3 rounded-lg text-sm font-semibold hover:bg-forest/90 transition-colors" data-id="element-92">
          Comprar ahora
        </a>
      </div>
    </div>;
}